/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateGuardianDto } from '../../models/create-guardian-dto';
import { GuardianDto } from '../../models/guardian-dto';

export interface AdminGuardianControllerManualCreate$Params {
  childId: string;
  centerId: string;
      body: CreateGuardianDto
}

export function adminGuardianControllerManualCreate(http: HttpClient, rootUrl: string, params: AdminGuardianControllerManualCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<GuardianDto>> {
  const rb = new RequestBuilder(rootUrl, adminGuardianControllerManualCreate.PATH, 'post');
  if (params) {
    rb.query('childId', params.childId, {});
    rb.query('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GuardianDto>;
    })
  );
}

adminGuardianControllerManualCreate.PATH = '/api/guardian/admin/manual';
